import { useIsCashJourneySelected } from "./useIsCashJourneySelected";

import { getIsPreconfigAvailable } from "@lib/getIsPreconfigAvailable";

import {
  useCarSelector,
  usePreconfigurationsSelector,
} from "@redux/reducers/appConfig";
import {
  useBusinessModelSelector,
  useCarConfigurationSelector,
} from "@redux/reducers/deal";

import { CUSTOMIZE_TYPES } from "@shared/constants";

export const useAvailableAdditionalEquipment = () => {
  const preconfigurations = usePreconfigurationsSelector();
  const { options: carOptions } = useCarSelector();
  const currentCar = useCarConfigurationSelector();

  const businessModel = useBusinessModelSelector();
  const isCashJourney = useIsCashJourneySelected();

  const { preconfiguration: currentPreconfig } = currentCar;

  const options = [];

  carOptions
    .filter(
      option =>
        currentPreconfig.options.includes(option.officialReference) &&
        option.type === CUSTOMIZE_TYPES.ACCESSORY
    )
    .forEach(option => {
      options.push({
        type: CUSTOMIZE_TYPES.ACCESSORY,
        item: option,
        selected: currentCar.accessory.some(
          accessory =>
            String(accessory.officialReference) ===
            String(option.officialReference)
        ),
      });
    });

  const basePreconfig = preconfigurations.find(
    p => p.lcdvCode === currentPreconfig.lcdvCode && p.isBasePreconfig
  );

  const basePreconfigId = basePreconfig?.id || null;
  const basePreconfigStatus = basePreconfig?.status || false;

  const filteredPreconfigurations = preconfigurations.filter(
    preconfiguration =>
      preconfiguration.lcdvCode === currentPreconfig.lcdvCode &&
      !preconfiguration.isBasePreconfig
  );

  if (
    (!basePreconfigId ||
      !getIsPreconfigAvailable(
        basePreconfigStatus,
        businessModel,
        isCashJourney
      )) &&
    filteredPreconfigurations.length === 1
  ) {
    return options;
  }

  filteredPreconfigurations.forEach(preconfiguration => {
    const pack = carOptions.filter(
      option =>
        option.type === CUSTOMIZE_TYPES.PACK &&
        preconfiguration.options.includes(option.officialReference)
    )[0];
    options.push({
      type: CUSTOMIZE_TYPES.PACK,
      item: { ...preconfiguration, pack, basePreconfigId, basePreconfigStatus },
      selected: currentPreconfig.id === preconfiguration.id,
    });
  });

  return options;
};
